module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-federation-controller"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns small-6 large-12"
  }, [_c('div', {
    staticClass: "row column"
  }, [_c('router-tab-headers', {
    attrs: {
      "tabs": _vm.tabs,
      "id": 'federation-vehicles',
      "activeIndex": 0,
      "deepLink": true
    }
  }, [_c('router-view')], 1)], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-879afe70!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/controllers/Federation.vue
// module id = 2617
// module chunks = 1